export enum LastLinkTypes {
  NEW_LAST_LINK = '@lastLink/NEW_LAST_LINK',
}

export interface INewLink {
  type: LastLinkTypes.NEW_LAST_LINK;
}
